import { useState } from 'react';
import ReactGA from 'react-ga4';
import styled from 'styled-components';
import { ampli } from '../../../../../ampli';
import { Icon } from '../../../../../components/common/icon/Icon';
import { YoutubePlayerModal } from '../../../../../components/custom/modal/popup/YoutubePlayerModal';
import { IPluvaAutoBusinessVideo } from './PluvaAutoBusinessPageContents';

interface VideoPlayerCardProps {
  video: IPluvaAutoBusinessVideo;
}

export const VideoPlayerCard = ({ video }: VideoPlayerCardProps) => {
  const [isYoutubeModalPopup, setIsYoutubeModalPopup] = useState<boolean>(false);

  const handleVideoClick = () => {
    ampli.pvmClickSalesVideoPlayButton({
      video_title: video.videoTitle,
    });
    ReactGA.event('pvm_click_sales_video_play_button', {
      video_title: video.videoTitle,
    });
    setIsYoutubeModalPopup(true);
  };
  const handleModalClose = () => setIsYoutubeModalPopup(false);

  return (
    <>
      <Container onClick={handleVideoClick}>
        <TopSection>
          <VideoThumbnailWrapper>
            <VideoThumbnail thumbnailUrl={video.thumbnailUrl} />
            <GreenChip>
              <Icon name={'AngleFillRight'} />
            </GreenChip>
          </VideoThumbnailWrapper>
        </TopSection>
        <BodySection>
          <VideoTitle>{video.videoTitle}</VideoTitle>
        </BodySection>
      </Container>

      {isYoutubeModalPopup && (
        <YoutubePlayerModal
          isShow={isYoutubeModalPopup}
          youtubeUrl={video.youtubeUrl}
          handleModalClose={handleModalClose}
        />
      )}
    </>
  );
};

const Container = styled.div`
  min-width: 250px;
  min-height: 200px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;

  border-radius: var(--radius-large, 16px);

  overflow: hidden;

  cursor: pointer;
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  border-radius: var(--radius-none, 0px);
  background: var(--Light-Scheme-Monochrome-grey30, #d5d5e3);
`;

const VideoThumbnailWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const VideoThumbnail = styled.div<{ thumbnailUrl: string }>`
  height: 167px;
  align-self: stretch;

  background: ${(props) => `url(${props.thumbnailUrl}) lightgray 50% / cover no-repeat`};
`;

const BodySection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
  align-self: stretch;

  padding: var(--radius-large, 16px) 0px;

  border-radius: var(--radius-none, 0px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const VideoTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */

  @media screen and (max-width: 768px) {
    color: var(--Light-Scheme-Monochrome-black, #232429);
    text-align: center;

    /* Display/XX-Large/xxl-bold */
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 26px */
  }
`;

const GreenChip = styled.div`
  display: flex;
  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);

  position: absolute;
  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);
`;
